import type { MasterProduct } from '@esf/shared';

export const demoMasterProducts: MasterProduct[] = [
  {
    id: 'MP-001', organisationId: 'ORG-001', name: 'Glasdon Civic Bench',
    category: 'seating', subcategory: 'Memorial Bench', model: 'Civic 1800',
    version: 1, isActive: true, manufacturer: 'Glasdon', manufacturerCountry: 'GB',
    materials: ['Recycled plastic lumber', 'Stainless steel fixings', 'Aluminium armrests'],
    certifications: ['ISO 14001', 'FSC Certified', 'BS EN 581-1'],
    carbonFootprint: 85.2, recyclabilityScore: 92, expectedLifespan: 25, repairabilityScore: 8.5,
    description: 'Recycled plastic memorial bench with engraved plaque option. Vandal-resistant, low-maintenance.',
    createdAt: '2024-01-20T10:00:00.000Z', updatedAt: '2024-08-15T14:00:00.000Z',
  },
  {
    id: 'MP-002', organisationId: 'ORG-001', name: 'Broxap Curved Bench',
    category: 'seating', subcategory: 'Public Bench', model: 'Curved 2400',
    version: 1, isActive: true, manufacturer: 'Broxap', manufacturerCountry: 'GB',
    materials: ['Iroko hardwood', 'Cast iron frame', 'Stainless steel bolts'],
    certifications: ['FSC Certified', 'BS EN 581-1', 'ISO 9001'],
    carbonFootprint: 112.8, recyclabilityScore: 78, expectedLifespan: 30, repairabilityScore: 9.0,
    description: 'Elegant curved hardwood bench with cast iron heritage-style frame. Ideal for waterfront locations.',
    createdAt: '2024-02-10T09:00:00.000Z', updatedAt: '2024-02-10T09:00:00.000Z',
  },
  {
    id: 'MP-003', organisationId: 'ORG-001', name: 'Glasdon SunPath LED Light',
    category: 'lighting', subcategory: 'Solar Path Light', model: 'SunPath LED 3000',
    version: 1, isActive: true, manufacturer: 'Glasdon', manufacturerCountry: 'GB',
    materials: ['Die-cast aluminium', 'Polycarbonate lens', 'Monocrystalline solar panel', 'LiFePO4 battery'],
    certifications: ['CE Marking', 'IP65', 'IK10'],
    carbonFootprint: 25.0, recyclabilityScore: 70, expectedLifespan: 15, repairabilityScore: 7.0,
    description: 'Off-grid solar LED pathway bollard light with dusk-to-dawn automation.',
    createdAt: '2024-03-01T10:00:00.000Z', updatedAt: '2024-03-01T10:00:00.000Z',
  },
  {
    id: 'MP-004', organisationId: 'ORG-001', name: 'Broxap Consort Bus Shelter',
    category: 'shelters', subcategory: 'Bus Shelter', model: 'Consort Heritage',
    version: 2, isActive: true, manufacturer: 'Broxap', manufacturerCountry: 'GB',
    materials: ['Powder-coated steel frame', 'Toughened glass panels', 'Polycarbonate roof'],
    certifications: ['BS EN 1090', 'ISO 14001', 'Secured by Design'],
    carbonFootprint: 320.0, recyclabilityScore: 72, expectedLifespan: 25, repairabilityScore: 7.0,
    description: 'Full-height bus shelter with optional solar lighting, real-time display, and anti-vandal glazing.',
    createdAt: '2024-04-15T08:00:00.000Z', updatedAt: '2025-11-10T16:00:00.000Z',
  },
  {
    id: 'MP-005', organisationId: 'ORG-001', name: 'Glasdon Jubilee Litter Bin',
    category: 'litter_recycling', subcategory: 'Litter Bin', model: 'Jubilee 110L',
    version: 2, isActive: true, manufacturer: 'Glasdon', manufacturerCountry: 'GB',
    materials: ['Durapol polymer', 'Galvanised steel liner'],
    certifications: ['ISO 14001'],
    carbonFootprint: 45.3, recyclabilityScore: 88, expectedLifespan: 15, repairabilityScore: 7.0,
    description: 'High-capacity litter bin with anti-fly-posting surface. Available in multiple colour options.',
    createdAt: '2024-05-01T09:00:00.000Z', updatedAt: '2025-02-20T11:00:00.000Z',
  },
  {
    id: 'MP-006', organisationId: 'ORG-001', name: 'Sheffield Cycle Stand',
    category: 'cycle', subcategory: 'Cycle Stand', model: 'Sheffield Stand Duo',
    version: 1, isActive: true, manufacturer: 'Broxap', manufacturerCountry: 'GB',
    materials: ['316 stainless steel tube'],
    certifications: ['Secured by Design'],
    carbonFootprint: 18.5, recyclabilityScore: 98, expectedLifespan: 30, repairabilityScore: 9.0,
    description: 'Classic Sheffield-style cycle stand in marine-grade stainless steel. Accommodates 2 bicycles.',
    createdAt: '2024-06-01T10:00:00.000Z', updatedAt: '2024-06-01T10:00:00.000Z',
  },
  {
    id: 'MP-007', organisationId: 'ORG-001', name: 'Marshalls Ferrocast Bollard',
    category: 'bollards_barriers', subcategory: 'Static Bollard', model: 'Ferrocast Heritage',
    version: 1, isActive: true, manufacturer: 'Marshalls', manufacturerCountry: 'GB',
    materials: ['Ferrocast polyurethane', 'Steel reinforcement core'],
    certifications: ['PAS 68', 'BS EN 12767'],
    carbonFootprint: 35.0, recyclabilityScore: 65, expectedLifespan: 20, repairabilityScore: 5.0,
    description: 'Heritage-style anti-ram bollard with steel reinforcement core. PAS 68 impact tested.',
    createdAt: '2024-07-01T10:00:00.000Z', updatedAt: '2024-07-01T10:00:00.000Z',
  },
  {
    id: 'MP-008', organisationId: 'ORG-001', name: 'Bailey Streetscene Notice Board',
    category: 'signage_display', subcategory: 'Notice Board', model: 'Heritage Board HB-1200',
    version: 1, isActive: true, manufacturer: 'Bailey Streetscene', manufacturerCountry: 'GB',
    materials: ['Powder-coated aluminium', 'Perspex cover', 'Anti-tamper fixings'],
    certifications: ['ISO 9001'],
    carbonFootprint: 45.0, recyclabilityScore: 85, expectedLifespan: 15, repairabilityScore: 8.0,
    description: 'Lockable heritage-style notice board with weather-resistant display area.',
    createdAt: '2024-08-01T09:00:00.000Z', updatedAt: '2024-08-01T09:00:00.000Z',
  },
  {
    id: 'MP-009', organisationId: 'ORG-001', name: 'Woodscape Timber Planter',
    category: 'planters', subcategory: 'Tree Planter', model: 'Clifton Planter 1200',
    version: 1, isActive: true, manufacturer: 'Woodscape', manufacturerCountry: 'GB',
    materials: ['FSC-certified oak', 'Stainless steel fixings', 'Waterproof liner'],
    certifications: ['FSC Certified', 'ISO 14001'],
    carbonFootprint: 65.0, recyclabilityScore: 88, expectedLifespan: 15, repairabilityScore: 8.0,
    description: 'Large oak tree planter with integrated drainage. Available in various sizes.',
    createdAt: '2024-09-01T10:00:00.000Z', updatedAt: '2024-09-01T10:00:00.000Z',
  },
  {
    id: 'MP-010', organisationId: 'ORG-001', name: 'SmartFlower Solar Unit',
    category: 'solar_power', subcategory: 'Solar Array', model: 'SmartFlower POP+',
    version: 1, isActive: true, manufacturer: 'SmartFlower', manufacturerCountry: 'AT',
    materials: ['Monocrystalline silicon cells', 'Aluminium petals', 'Steel base', 'Lithium-ion battery'],
    certifications: ['CE Marking', 'IEC 61215', 'IEC 62109', 'MCS Certified'],
    carbonFootprint: 850.0, recyclabilityScore: 72, expectedLifespan: 25, repairabilityScore: 7.0,
    description: 'Iconic solar flower installation generating up to 6,200 kWh/year with integrated battery storage.',
    hasBattery: true, batteryCapacityKwh: 2.5,
    createdAt: '2024-03-15T10:00:00.000Z', updatedAt: '2024-03-15T10:00:00.000Z',
  },
  {
    id: 'MP-011', organisationId: 'ORG-001', name: 'Steora Smart Solar Bench',
    category: 'solar_power', subcategory: 'Solar Bench', model: 'Steora Smart Bench',
    version: 1, isActive: true, manufacturer: 'Include Ltd', manufacturerCountry: 'HR',
    materials: ['Aluminium frame', 'Recycled plastic seating', 'Monocrystalline solar panel', 'LiFePO4 battery'],
    certifications: ['CE Marking', 'IEC 62109', 'IP54'],
    carbonFootprint: 195.0, recyclabilityScore: 68, expectedLifespan: 15, repairabilityScore: 6.5,
    description: 'Smart solar bench with wireless and USB charging, Wi-Fi hotspot, and environmental sensors.',
    hasBattery: true, batteryCapacityKwh: 1.2,
    createdAt: '2024-05-20T09:00:00.000Z', updatedAt: '2024-05-20T09:00:00.000Z',
  },
  {
    id: 'MP-012', organisationId: 'ORG-001', name: 'Cornilleau Outdoor Table Tennis',
    category: 'other', subcategory: 'Play Equipment', model: 'Cornilleau Park Outdoor',
    version: 1, isActive: false, manufacturer: 'Cornilleau', manufacturerCountry: 'FR',
    materials: ['Resin laminate surface', 'Galvanised steel frame', 'Stainless steel net'],
    certifications: ['EN 14468-1', 'CE Marking'],
    carbonFootprint: 120.0, recyclabilityScore: 65, expectedLifespan: 12, repairabilityScore: 5.0,
    description: 'Permanent outdoor table tennis table for public use. Anti-vandal design with steel net. Discontinued.',
    createdAt: '2024-04-01T10:00:00.000Z', updatedAt: '2025-09-15T14:00:00.000Z',
  },
];
